import { useMemo } from 'react'
import { useWallet } from '@web/walter-lib/stream'
import { keyBy } from 'lodash'
import { balancesPerCurrency } from '~utils/data/processBalance'
import {
    useCommonCMSConfig,
    useFuturesTradingBalances,
    useGetWalletBalance,
    useSpotTradingBalances,
    useWalletBalances,
} from '~api'

// eslint-disable-next-line complexity
export function useBalancesPerCurrency() {
    const { data, isValidating: isConfigLoading } = useCommonCMSConfig()
    const { isFuturesAvailable, blockTradingSocket, showLockedBalance } = data?.features || {}

    //TODO: if wallet empty => sub message will not be sent by server => loading forever
    const { data: wallet } = useWallet()
    const { data: walletData, isLoading: isWalletDataLoading } = useGetWalletBalance()

    const { data: spot, error: spotError } = useSpotTradingBalances()
    const { data: futures, error: futuresError } = useFuturesTradingBalances({
        shouldRequest: isFuturesAvailable && !isConfigLoading,
    })

    // TODO: add this hack because if wallet is empty, server will not send sub message => loading forever
    const { data: walletReq, error: walletReqError } = useWalletBalances()

    const futuresBalances = useMemo(() => keyBy(futures, 'currency'), [futures])
    const spotBalances = useMemo(() => keyBy(spot, 'currency'), [spot])
    const balances = useMemo(
        () =>
            balancesPerCurrency({
                wallet: wallet || walletData || {},
                spot: spotBalances,
                futures: futuresBalances,
                showLockedBalance,
            }),
        [wallet, spotBalances, futuresBalances, walletData, showLockedBalance]
    )

    const isWallet = !!walletReq || !!walletReqError
    const isSpot = !!spot || !!spotError || blockTradingSocket
    const isFutures = !!futuresError || !!futures || (!isFuturesAvailable && !isConfigLoading) || blockTradingSocket

    return {
        balances,
        isLoading: isWalletDataLoading || !(isSpot && isFutures && isWallet),
    }
}
